import Flex from "../Flex/Flex.web";
import { ScrollContainerProps } from "./ScrollContainer.props";

// Creates a vertically-scrolling container
// That expands to the height and width of the parent container
export default function ScrollContainer({
  showFade,
  children,
  ...props
}: ScrollContainerProps) {
  return (
    <Flex
      direction="column"
      flexGrow={1}
      maxH="full"
      overflowY="auto"
      position="relative"
      {...props}
    >
      <Flex
        direction="column"
        overflowY="auto"
        {...props}
        _after={{
          position: "absolute",
          bottom: "0",
          height: "100%",
          width: "100%",
          content: "''",
          pointerEvents: "none",
          background: showFade
            ? `linear-gradient(
            to top,
            var(--chakra-colors-bg) 0%,
            color-mix(in srgb, var(--chakra-colors-bg) 25%, transparent) 20%,
            transparent 100%
          )`
            : "",
        }}
      >
        {children}
      </Flex>
    </Flex>
  );
}
